import logger from '@/features/logger/constants/logger';
import { create } from 'zustand';

const useUpdateLock = create<{
  isLocked: boolean;
  lockUpdate: () => void;
  unlockUpdate: () => void;
}>((set) => ({
  isLocked: false,
  lockUpdate: () => {
    // eslint-disable-next-line i18n-text/no-en
    logger.debug('core.app', 'Locking the update check process');
    set({ isLocked: true });
  },
  unlockUpdate: () => {
    // eslint-disable-next-line i18n-text/no-en
    logger.debug('core.app', 'Unlocking the update check process');
    set({ isLocked: false });
  },
}));

export default useUpdateLock;
